module.exports = __webpack_public_path__ + "img/jin9.7f4316ec.png";